module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_duo_rec_13.d0dcca51.png";